// Talking to the console API. The session cookie travels by itself (same site only),
// and the server refuses changes that don't come from this page's own address.

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export async function api<T = unknown>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/console-api${path}`, {
      method,
      credentials: 'same-origin',
      headers: body === undefined ? {} : { 'content-type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(0, 'offline', "Can't reach the console. Check the connection and try again.");
  }
  const isJson = (res.headers.get('content-type') ?? '').startsWith('application/json');
  const data = isJson ? await res.json() : null;
  if (!res.ok) throw new ApiError(res.status, data?.error ?? 'error', data?.message ?? 'Something went wrong. Please try again.');
  return data as T;
}

export const message = (e: unknown): string => (e instanceof Error ? e.message : 'Something went wrong. Please try again.');
